<template>
  <div class="content-wrapper pb-4">
    <PageHeader
      screen-name="Registro de vacinação"
      :link-items="linkItems"
    />

    <ErroIdInexistenteModal
      :modal-show="modalError.showModal"
      :type-modal="modalError.typeModal"
      :case-modal="modalError.caseModal"
      @confirmed="redirectToSelectEmpresa"
    />

    <div class="card card-content px-2">
      <div
        v-if="canShowImportFlow && !isTutorialView()"
        class="card-top pt-2"
      >
        <h1>{{ title }}</h1>
        <div class="actions-row py-2">
          <b-button
            variant="none"
            class="btn"
            :class="{ 'btn-active': isRegistroView() }"
            @click="() => {showListView()}"
          >
            Registro
          </b-button>

          <b-button
            variant="none"
            v-if="canImport && !isSuporte"
            class="btn"
            :class="{ 'btn-active': isImportView()}"
            @click="() => {showImportView()}"
          >
            Importação
          </b-button>
        </div>
      </div>
      <ListRegistroVacinacao
        v-if="isRegistroView() && loadScreen && !this.getSearch.baseNacional"
        :params="getSearch"
      />
      <ListRegistroVacinacaoBaseNacional
          v-if="isRegistroView() && loadScreen && this.getSearch.baseNacional"
          :params="getSearch"
      />
      <ImportarVacinados
        v-else-if="isImportView() && loadScreen && canImport"
        :params="getSearch"
      />
      <TutorialImportacao v-else-if="isTutorialView()" />
    </div>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import ListRegistroVacinacao from '@/views/custom-pages/Vacinacao/Pages/ListRegistro/List-registro-vacinacao.vue'
import ImportarVacinados from '@/views/custom-pages/Vacinacao/Pages/Importacao/ImportarVacinados.vue'
import TutorialImportacao from '@/views/custom-pages/Vacinacao/Pages/TutorialImportacao/TutorialImportacao.vue'
import { VACINACAO_VIEWS } from '@/views/custom-pages/Vacinacao/Helpers/utils'
import ErroIdInexistenteModal from '@/views/components/custom/modals/ErroIdInexistenteModal.vue'
import {actions, subjects} from "@/libs/acl/rules";
import ListRegistroVacinacaoBaseNacional
  from "@/views/custom-pages/Vacinacao/Pages/ListRegistro/List-registro-vacinacao-base-nacional.vue";

export default {
  components: {
    ListRegistroVacinacaoBaseNacional,
    TutorialImportacao,
    ImportarVacinados,
    ListRegistroVacinacao,
    ErroIdInexistenteModal,
    PageHeader,
    BButton,
  },
  data() {
    return {
      title: 'Resumo do registro',
      canShowImportFlow: false,
      loadScreen: false,
      getSearch: {
        campanha: {},
        unidade: {},
        empresa: {},
        endereco: {},
        grupo: {},
        baseNacional: false
      },
      linkItems: [
        {
          name: 'Registro de vacinação',
          active: true,
        },
      ],
      modalError: {
        showModal: false,
        typeModal: 'error',
        caseModal: 'selecaoInvalida',
      },
      canImport: null,
      isSuporte: false
    }
  },
  mounted() {
    this.isSuporte = this.$store.state.sessions.userData.perfis[0].chave === 'SUPORTE';

    if(!this.$route.params.empresa && !this.$route.params.grupo) {
      this.setModalError();
      return;
    }else{
      this.loadScreen = true
    }
    this.getSearch = this.$route.params
    this.canImport = !this.getSearch.baseNacional || (this.getSearch.baseNacional && this.getSearch.empresa);
    this.redirectUserByProfileKind()
  },
  updated() {
    this.redirectUserByProfileKind()
  },
  methods: {
    setModalError() {
      this.modalError.showModal = true
    },
    updatePageTitle(title, breadcrumbText) {
      this.title = title
      this.$data.linkItems[0].name = breadcrumbText
    },
    showListView() {
      if (this.getActiveView() !== VACINACAO_VIEWS.REGISTRO) this.redirectTo(VACINACAO_VIEWS.REGISTRO)
      this.updatePageTitle('Resumo do registro', 'Registro de vacinação')
    },
    showImportView() {
      if (this.getActiveView() !== VACINACAO_VIEWS.IMPORTAR) this.redirectTo(VACINACAO_VIEWS.IMPORTAR)
      this.updatePageTitle('Importação de vacinados', 'Importar vacinados')
    },
    showTutorialView() {
      if (this.getActiveView() !== VACINACAO_VIEWS.TUTORIAL) this.redirectTo(VACINACAO_VIEWS.TUTORIAL)
      this.updatePageTitle('Importação de vacinados', 'Tutorial importação')
    },
    getActiveView() {
      return this.$route.query.v ?? null
    },
    isRegistroView() {
      return this.getActiveView() === VACINACAO_VIEWS.REGISTRO
    },
    isImportView() {
      return this.getActiveView() === VACINACAO_VIEWS.IMPORTAR
    },
    isTutorialView() {
      return this.getActiveView() === VACINACAO_VIEWS.TUTORIAL
    },
    redirectTo(view = VACINACAO_VIEWS.REGISTRO) {
      const route = this.isSuporte 
        ? "resumo-registro-vacinacao-list" 
        : "resumo-registro-vacinacao";

      this.$router.push(`${route}?v=${view.toLowerCase()}`);
    },
    redirectUserByProfileKind() {
      this.canShowImportFlow = this.$can(actions.IMPORTAR, subjects.IMPORTACAO_PLANILHA_VACINADOS)
      if (!this.canShowImportFlow) {
        this.showListView()
        return
      }

      const activeView = this.getActiveView()
      if (activeView === VACINACAO_VIEWS.IMPORTAR) this.showImportView()
      if (activeView === VACINACAO_VIEWS.REGISTRO) this.showListView()
      if (activeView === VACINACAO_VIEWS.TUTORIAL) this.showTutorialView()
      if (!activeView) this.showListView()
    },
    redirectToSelectEmpresa() {
      const routeName = this.isSuporte 
        ? 'registro-vacinados-list' 
        : 'empresa-vacinacao-select';

      this.$router.push({ name: routeName });
    },
  },
}

</script>

<style scoped lang="scss">
.actions-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;

  button {
    padding: .75em 2em;
  }

  :is(.btn-active) {
    background-color: #2772C0;
    color: #FFF
  }
}

</style>
